import apps from "@services/applications";

export default [
  {
    path: "/app/channel-creator",
    name: "channel-creator",
    meta: {
      module: "channel-creator",
      application: apps.Modules.ChannelCreator.Id,
      title: "Channel Creator"
    },
    component: () => import("@ChannelCreator/views/ChannelCreator.vue"),
    children: [
      {
        path: "workspace/target-node-editor",
        name: "target-node-workspace",
        meta: {
          module: "channel-creator",
          application: apps.Modules.ChannelCreator.Id
        },
        component: () => import("@ChannelCreator/components/Workspaces/TargetCatalogNodeDetails.vue")
      }
    ]
  }
];
